"use client";

import React from "react";
import { GraduationCap, ShieldAlert } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DataInterpretation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  const credentials = ["PhD Biomechanics", "MSc Sports Biomechanics", "MSc Data Science"];
  return <section id="datainterpretationbio" data-nav="light" ref={ref} className="relative overflow-hidden bg-background py-16 text-foreground sm:py-24">
      <div className={`mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            Data is useful when it is interpreted properly
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted-foreground sm:text-xl">
            Measurements are interpreted in context, taking account of the test
            performed, the individual&apos;s goals and the limitations of each
            measurement.
          </p>
        </div>

        <div className="mt-12 sm:mt-16">
          <Card className="border border-border/80 bg-card shadow-sm">
            <CardContent className="p-6 sm:p-10">
              <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between">
                <div>
                  <h3 className="text-xl font-semibold tracking-tight text-foreground sm:text-2xl">
                    Dr Andrew Greenhalgh — Founder &amp; Head of Biomechanics
                  </h3>
                  <div className="mt-4 flex flex-wrap items-center gap-2">
                    {credentials.map((cred, i) => <Badge key={cred} data-index={i} variant="secondary" className="px-3 py-1 text-xs font-medium text-secondary-foreground">
                        <GraduationCap className="size-3.5 text-primary" />
                        <span>{cred}</span>
                      </Badge>)}
                  </div>
                </div>
              </div>

              <Separator className="my-6" />

              <div className="flex items-start gap-3 rounded-lg border border-border/60 bg-muted/40 p-4 text-sm leading-relaxed text-muted-foreground">
                <ShieldAlert className="mt-0.5 size-5 shrink-0 text-muted-foreground/80" />
                <p>
                  Dr Greenhalgh is a specialist biomechanist and is not a
                  physiotherapist or medical doctor. Clinical assessment and
                  treatment are undertaken by appropriately qualified
                  practitioners where required.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}